// src/pages/FormSuccess.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function FormSuccess() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">
      <h1 className="text-3xl font-bold mb-4">Dziękuję za kontakt!</h1>
      <p className="text-lg mb-6">
        Twoja wiadomość została wysłana. Skontaktuję się z Tobą wkrótce, aby omówić wszystkie szczegóły.
      </p>
      <button
        onClick={() => navigate("/")}
        className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Powrót na stronę główną
      </button>
    </div>
  );
}
